import script from "./PageHeaderActionItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageHeaderActionItem.vue?vue&type=script&lang=ts&setup=true"

import "./PageHeaderActionItem.vue?vue&type=style&index=0&id=8506e4a0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8506e4a0"]])

export default __exports__